import * as React from "react";
import { FunctionComponent } from "react";
import { SvgProps } from "./SvgProps";

const ArrowLeft: FunctionComponent<SvgProps> = ({
  fill = "currentColor",
  ...props
}) => {
  return (
    <span role="img" className="anticon">
      <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={fill}
          d="M6.48779 15.5949C6.48779 15.8962 6.61837 16.1976 6.8494 16.4185L13.4789 23.038C13.7199 23.269 13.9811 23.3795 14.2724 23.3795C14.9052 23.3795 15.3673 22.9275 15.3673 22.3147C15.3673 21.9933 15.2467 21.7221 15.0358 21.5212L12.7757 19.231L9.86279 16.5692L12.2032 16.7098H24.3773C25.0402 16.7098 25.5023 16.2478 25.5023 15.5949C25.5023 14.9319 25.0402 14.4699 24.3773 14.4699H12.2032L9.87284 14.6105L12.7757 11.9487L15.0358 9.65849C15.2467 9.4576 15.3673 9.18639 15.3673 8.86496C15.3673 8.25224 14.9052 7.80023 14.2724 7.80023C13.9811 7.80023 13.7099 7.91072 13.4487 8.16184L6.8494 14.7612C6.61837 14.9822 6.48779 15.2835 6.48779 15.5949Z"
        />
      </svg>
    </span>
  );
};

export default ArrowLeft;
